// components/Offline/OfflineSnackbar.jsx

import React, { useEffect, useState, useMemo } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useOnlineStatus } from '../../contexts/OnlineStatusContext';

const OfflineSnackbar = () => {
  const { isOnline } = useOnlineStatus();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isOnline]);

  const anchorOrigin = useMemo(() => ({ vertical: 'bottom', horizontal: 'center' }), []);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={anchorOrigin}
      onClose={handleClose}
      sx={{
        '& .MuiSnackbarContent-root': {
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        },
      }}
    >
      <Alert
        onClose={handleClose}
        severity="warning"
        variant="filled"
        role="alert"
        data-testid="offline-snackbar"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{
          width: '80vw',
          backgroundColor: '#2e2e2e',
          color: '#fff',
          fontWeight: 500,
          boxShadow: 4,
          borderRadius: 2,
          py: 1.5,
          px: 3,
          minHeight: '56px',
          fontSize: '0.95rem',
          alignItems: 'center',
        }}

      >
        You are currently offline. Changes may not be saved.
      </Alert>
    </Snackbar>
  );
};

export default OfflineSnackbar;
